import type { CallCenterModel } from '../../../../api/interfaces/callCenterModel';

export type CardLinksProps = Pick<
  CallCenterModel,
  | 'statusForOrdersNotShown'
  | 'showOrderDetails'
  | 'quickTools'
  | 'showPreviousOrderDays'
  | 'showQuickToolsOnPage'
  | 'maxNoOfOrders'
  | 'helpForYouCarouselOrder'
  | 'narvarBaseUrl'
  | 'returnCardsPreviousOrderDays'
  | 'returnCardsActiveReturnDays'
  | 'showReturnCards'
  | 'reiSalesConfig'
  | 'selectedCategory'
  | 'newMemberWelcomeDays'
  | 'showNewMemberWelcome'
  | 'showRewardsCard'
>;

export const CardLinksKeys: (keyof CardLinksProps)[] = [
  'statusForOrdersNotShown',
  'showOrderDetails',
  'quickTools',
  'showPreviousOrderDays',
  'showQuickToolsOnPage',
  'maxNoOfOrders',
  'helpForYouCarouselOrder',
  'narvarBaseUrl',
  'returnCardsPreviousOrderDays',
  'returnCardsActiveReturnDays',
  'showReturnCards',
  'reiSalesConfig',
  'selectedCategory',
  'newMemberWelcomeDays',
  'showNewMemberWelcome',
  'showRewardsCard',
];
